import React, { useState } from "react";
import embLabels from "../../config/emb-labels-en.json";
const RoutingPlcTable = (props) => {
  const { data,updateVLan } = props;

  const newData = { ...data };
  const [accessEnable, setAccessEnable] = useState(newData?.isEnabled );
  return (
    <>
      <tr className="text-center">
        <td>{newData.vlanToRoute}</td>
        <td>{newData.destinationIpAddress}</td>
        <td>{newData.netmask}</td>
        <td>{newData.interfaceVal}</td>
        <td>{newData.gateWayViaVlan}</td>
        <td>
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input asCompatible"
            name="vlanOptions"
            id={`vlanOptionsValues ${newData.id}`}
            value={accessEnable}
            checked={accessEnable}
            onChange={(e) => {
            setAccessEnable(e.target.checked);            
           updateVLan(e.target.checked, newData);
          }}
          />
          <label
            className="custom-control-label line-height-25"
            htmlFor={`vlanOptionsValues ${newData.id}`}
          >
            
        </label>
         
        </div>
        </td>
      </tr>
    </>
  );
};

export default RoutingPlcTable;
